import { render, staticRenderFns } from "./orderDigit.vue?vue&type=template&id=cfa82a14"
import script from "./orderDigit.vue?vue&type=script&lang=js"
export * from "./orderDigit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports